import React, { useEffect, useState, Fragment } from "react";
import $, { data } from "jquery";
import services from "../services";
import { trackPromise } from "react-promise-tracker";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { makeStyles } from "@material-ui/core/styles";
import tokenService from "../../../Common/tokenDecoder";
import VisibilityRoundedIcon from "@material-ui/icons/VisibilityRounded";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { TextField } from "@material-ui/core";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { Checkbox } from "@material-ui/core";
import { LoadingMaterialTable } from "../../../Common/table";
import MessageModal from "../../../UI/Modal/MessageModal";
import { CardSuspendRemarkSchema } from "../CardSuspendRemarkSchema";
import Joi from "@hapi/joi";
import { validateProperty, validate } from "../../Common";
import FormHelperText from "@material-ui/core/FormHelperText";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4, 6, 9),
    borderRadius: 10,
    width: 600,
  },
  root: {
    "& > *": {
      margin: theme.spacing(5),
    },
  },
  remark: {
    width: 500,
  },
}));

export const CardSuspendListing = (props) => {
  
  const {cardSuspendData, afterSuccessfulyChanged}= props;
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState({
    firstName: "",
    cardNumber: "",
    registrationNumber: "",
    remark: "",
  });

  const [errors, setErrors] = useState({});
  const [cardSuspendFiltering, setCardSuspendFiltering] = useState([]);
  const handleClose = () => {
    setOpen(false);
  };
  const [cardSuspendDetails, setCardSuspendDetails] = useState({});
  const [cardInactivateDetails, setCardInactivateDetails] = useState({});
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Completed Success",
  });

 const schema = Joi.object(CardSuspendRemarkSchema).options({
  allowUnknown: true,
 });

  function validateInputs(target) {
  const error = { ...errors };
    const errorMessage = validateProperty(target, CardSuspendRemarkSchema);
     errorMessage
       ? (error[target.name] = errorMessage)
      : delete error[target.name];

   setErrors(error);
  }

  useEffect(() => {
    trackPromise(setCardSuspendData());
  }, [cardSuspendData]);

  useEffect(() => {
    setCardSuspendDetails({
      ...cardSuspendDetails,
      remark: modalData.remark,
    });
  }, [modalData]);

  useEffect(() => {
    setCardInactivateDetails({
      ...cardInactivateDetails,
      remark: modalData.remark,
    });
  }, [modalData]);

  function handleClick(data) {
    setModalData({
      ...modalData,
      name: data.firstName,
      cardNo: data.cardNumber,
      registerNo: data.registrationNumber,
      remark: data.remark,
    });
    setOpen(true);

    var token = tokenService.getUserDetailsFromToken();

    setCardSuspendDetails({
      ...cardSuspendDetails,
      cardID: data.cardID,
      createdBy: parseInt(token.id),
    });

    setCardInactivateDetails({
      ...cardInactivateDetails,
      cardID: data.cardID,
      createdBy: parseInt(token.id),
    });
 
  }

  async function handleSuspend(e) {
    setOpen(false);
    e.preventDefault();
    const remark = modalData.remark;
      if(remark.value !== null){
      const response = await services.updateSuspendCard(cardSuspendDetails);
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: response.statusCode,
        disciption: response.message,
      });
      setTimeout(() => {
        modalDismissHandler();
      }, 3000);
      }
      else{
        setMessageModel({
          ...messageModel,
            hidden: false,
            type:'Error',
            disciption: 'The Remark is Mandotory to Suspend the Card',
          });
          setTimeout(() => {
            modalDismissHandler();
          }, 3000);
      }
  
  }

  async function handleInactivate(e) {
    setOpen(false);
    e.preventDefault();
    if(modalData.remark !== null){
    const response = await services.updateInactiveCard(cardInactivateDetails);
    setMessageModel({
      ...messageModel,
      hidden: false,
      type: response.statusCode,
      disciption: response.message,
    });
      afterSuccessfulyChanged(response.statusCode);
      setTimeout(() => {
        modalDismissHandler();
      }, 1500);
    }else{
    setMessageModel({
    ...messageModel,
      hidden: false,
      type:'Error',
      disciption: 'The Remark is Mandotory to Inactivate the Card',
    });
      setTimeout(() => {
        modalDismissHandler();
      }, 3000);
  }
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function handleChange(e) {
    const remark = e.target.value;
    setModalData({
      ...modalData,
      remark: remark,
    });
  }

  async function setCardSuspendData() {
    await setCardSuspendFiltering(cardSuspendData);
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <LoadingMaterialTable
        title=""
        columns={[
          { title: "Card Number", field: "cardNumber" },
          { title: "Registration Number", field: "registrationNumber" },
          { title: "First Name ", field: "firstName" },
          { title: "Name to be Printed", field: "nameToBePrinted" },
          {
            title: "View",
            field: "view",
            render: (data) => (
              <VisibilityRoundedIcon
                onClick={() => handleClick(data)}
                style={{ cursor: "pointer" }}
              >
                {" "}
              </VisibilityRoundedIcon>
            ),
          },
        ]}
        data={cardSuspendFiltering}
      />

      <div>
        <Modal
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.root}>
              <div className={classes.paper}>
                <div>
                  <TextField
                    fullWidth
                    label="Name"
                    type="text"
                    id="name"
                    name="name"
                    value={modalData.name}
                  />
                </div>
                <br />
                <div>
                  <TextField
                    fullWidth
                    label="Card Number"
                    type="text"
                    id="cardNo"
                    name="cardNo"
                    value={modalData.cardNo}
                  />
                </div>
                <br />
                <div>
                  <TextField
                    fullWidth
                    label="Registration Number"
                    type="text"
                    id="registerNo"
                    name="registerNo"
                    value={modalData.registerNo}
                  />
                </div>
                <br />
                <div>
                  <TextareaAutosize
                    aria-label="empty textarea"
                    rowsMin={5}
                    className={classes.remark}
                    placeholder="Add a Remark to Suspend or Inactivate"
                    id="remark"
                    name="remark"
                    value={modalData.remark}
                    onChange={(e) => handleChange(e)}
                  ></TextareaAutosize>
                   {errors["remark"] && (
                      <FormHelperText error>
                        {errors["remark"]}
                      </FormHelperText>
                    )} 
                </div>
                <br />
                <input
                  type="submit"
                  className="btn btn-primary pull-left"
                  value="Suspend"
                  onClick={(e) => trackPromise(handleSuspend(e))}
                />
                <input
                  type="button"
                  className="btn btn-primary  "
                  value="Inactive"
                  onClick={(e) => trackPromise(handleInactivate(e))}
                />
              </div>
            </div>
          </Fade>
        </Modal>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
      />
    </Fragment>
  );
};
